import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "full-height full-width grouper-body-container min-height" }
const _hoisted_2 = { class: "full-width full-height grouper-body-splitter-container" }
const _hoisted_3 = { class: "iodine-border full-height min-height" }
const _hoisted_4 = { class: "iodine-border full-height min-height" }
const _hoisted_5 = { class: "iodine-border full-height min-height" }
const _hoisted_6 = { class: "iodine-border full-height min-height" }

import {computed} from 'vue';
import CodesPane from 'components/codes/CodesPane.vue';
import ResourcesPane from 'components/resources/ResourcesPane.vue';
import SearchPane from 'components/search/SearchPane.vue';
import ReferencesPane from 'components/references/ReferencesPane.vue';
import ReferencesEmbedded from 'components/references/ReferencesPaneCompact.vue';
import { useLayoutStore } from 'stores/layout-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperBodyFullscreen',
  setup(__props) {

const layoutStore = useLayoutStore();

const noOfSplits = computed(() =>
    (layoutStore.isCodesSelected ? 1 : 0) +
    (layoutStore.isSearchSelected ? 1 : 0) +
    (layoutStore.isReferencesSelected ? 1 : 0) +
    (layoutStore.isResourcesSelected ? 1 : 0)
)

const splitter1ModelValue = computed(() => {
  if (!layoutStore.isCodesSelected) {
    return 0;
  }

  let value = 100/noOfSplits.value;

  if (layoutStore.isSearchSelected) {
    value = value / 2;
  }

  return value;
});

const splitter1Disabled = computed(() => {
  return !layoutStore.isCodesSelected || noOfSplits.value == 1;
});

const splitter2ModelValue = computed(() => {
  if (!layoutStore.isSearchSelected) {
    return 0;
  }

  if (layoutStore.isSearchSelected) {

    if (noOfSplits.value == 1 || (noOfSplits.value == 2 && layoutStore.isCodesSelected)) {
      return 100;
    } else if (noOfSplits.value == 3 || (noOfSplits.value == 2 && !layoutStore.isCodesSelected)) {
      return 67;
    }
  }

  let leftSectionsVisible = 0;
  if (layoutStore.isCodesSelected) {
    leftSectionsVisible += 1;
  }

  return 100/(noOfSplits.value - leftSectionsVisible);
});

const splitter2Disabled = computed(() => {
  return !layoutStore.isSearchSelected || (!layoutStore.isReferencesSelected && !layoutStore.isResourcesSelected);
});

const splitter3ModelValue = computed(() => {
  if (!layoutStore.isReferencesSelected) {
    return 0;
  }
  let leftSectionsVisible = 0;

  if (layoutStore.isCodesSelected) {
    leftSectionsVisible += 1;
  }

  if (layoutStore.searchSelected) {
    leftSectionsVisible += 1;
  }

  return 100/(noOfSplits.value - leftSectionsVisible);
});

const splitter3Disabled = computed(() => {
  return !layoutStore.isReferencesSelected || !layoutStore.isResourcesSelected;
});


return (_ctx: any,_cache: any) => {
  const _component_q_splitter = _resolveComponent("q-splitter")!
  const _component_q_slide_transition = _resolveComponent("q-slide-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_slide_transition, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createVNode(_component_q_splitter, {
            "model-value": splitter1ModelValue.value,
            disable: splitter1Disabled.value,
            class: _normalizeClass(["grouper-body-splitter", {
                  'grouper-body-splitter-disabled': splitter1Disabled.value,
                  'grouper-body-splitter-hide-left': splitter1ModelValue.value == 0,
                  'grouper-body-splitter-hide-right': splitter1ModelValue.value == 100
                }]),
            "separator-style": "width: 6px; background-color: #F0F6FA;"
          }, {
            before: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(CodesPane)
              ])
            ]),
            after: _withCtx(() => [
              _createVNode(_component_q_splitter, {
                "model-value": splitter2ModelValue.value,
                disable: splitter2Disabled.value,
                class: _normalizeClass(["grouper-body-splitter", {
                      'grouper-body-splitter-disabled': splitter2Disabled.value,
                      'grouper-body-splitter-hide-left': splitter2ModelValue.value == 0,
                      'grouper-body-splitter-hide-right': splitter2ModelValue.value == 100
                    }]),
                "separator-style": "width: 6px; background-color: #F0F6FA;"
              }, {
                before: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(SearchPane)
                  ])
                ]),
                after: _withCtx(() => [
                  _createVNode(_component_q_splitter, {
                    "model-value": splitter3ModelValue.value,
                    disable: splitter3Disabled.value,
                    class: _normalizeClass(["grouper-body-splitter full-height", {
                          'grouper-body-splitter-disabled': splitter3Disabled.value,
                          'grouper-body-splitter-hide-left': splitter3ModelValue.value == 0,
                          'grouper-body-splitter-hide-right': splitter3ModelValue.value == 100
                        }]),
                    "separator-style": "width: 6px; background-color: #F0F6FA;"
                  }, {
                    before: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _withDirectives(_createVNode(ReferencesEmbedded, null, null, 512), [
                          [_vShow, noOfSplits.value > 1]
                        ]),
                        _withDirectives(_createVNode(ReferencesPane, null, null, 512), [
                          [_vShow, noOfSplits.value==1]
                        ])
                      ])
                    ]),
                    after: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(ResourcesPane)
                      ])
                    ]),
                    _: 1
                  }, 8, ["model-value", "disable", "class"])
                ]),
                _: 1
              }, 8, ["model-value", "disable", "class"])
            ]),
            _: 1
          }, 8, ["model-value", "disable", "class"]), [
            [_vShow, noOfSplits.value > 0]
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})